module.exports = __webpack_public_path__ + "87749c6eb5666f5eeb4770eba1c9b8dc.svg";